import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActionArea from '@mui/material/CardActionArea'
import { HelpCenterCardProps } from './_props'
import { sxs } from './_sxs'

export const HelpCenterCard = ({
    icon,
    title,
    description,
    buttonContent,
    url,
    handleClick,
}: HelpCenterCardProps) => (
    <Card sx={[sxs.card, url ? sxs.cardHoverable : null]}>
        <CardActionArea
            disableRipple={!url}
            disableTouchRipple={!url}
            sx={[sxs.cardActionArea, !url && sxs.cardActionAreaDisabledHover]}
            component={url ? 'a' : 'div'}
            href={url ?? '#'}
            target="_blank"
            rel="noreferrer noopener"
            onClick={handleClick}
        >
            <CardContent sx={sxs.cardContent}>
                {icon}
                <Typography sx={sxs.cardTitle}>{title}</Typography>
                <Typography sx={sxs.cardDescription}>{description}</Typography>
            </CardContent>
            {buttonContent}
        </CardActionArea>
    </Card>
)
